import React from "react";
import { connect } from "react-redux";
import { getLotes, eliminarLote } from "./LoteService";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import "../../styles/Empresa.css";
import { Link } from "react-router-dom";
import { Modal, Row, Col, Container, Button } from "react-bootstrap";
import Navbar from "../home/Navbar";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import visibility from "../../styles/icons/visibility.svg";
import deleteIcon from "../../styles/icons/delete.svg";
import ExclamacionIcon from "../../styles/icons/exclamation-circle.svg";
import search from "../../styles/icons/search.svg";
import Spinner from "react-bootstrap/Spinner";
import { ReactComponent as Delete } from "../../assets/images/icons/delete.svg";
import ComponenteVacio from "../componentes/avisos/ComponenteVacio";
import ModalEliminarConDetalles from "../componentes/modales/ModalEliminarConDetalles.js";
import { swipeActions } from "../../assets/js/scripts/swipeActions";

class LotesPublicar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRecibo: {
        nombre: "",
        fechaImportacion: "",
        descripcion: "",
        cantDocumentos: "",
        tipoDocumento: "",
        estado: "",
        estadoMTESS: false,
      },
      lote: {},
      dialogEliminarLote: false,
      mostrarMensajeFlash: false,
      openPantallaCarga: false,
      lotes: [],
      page: 0,
      pageSize: 10,
      totalCount: 0,
      totalPages: 0,
      search: "",
      loading: true,
    };
    localStorage.setItem("urlRaiz", window.location.href);
    this.tableRef = React.createRef();
  }

  handleDialogEliminarLote = (value, lote) => {
    this.setState({
      dialogEliminarLote: value,
      lote: lote,
    });
  };
  handleCerrarDialogEliminarLote = () => {
    this.setState({
      dialogEliminarLote: false,
    });
  };
  handleDelete = () => {
    this.setState({ openPantallaCarga: true, dialogEliminarLote: false });
    eliminarLote(this.state.lote.id).then((response) => {
      if (response.error) {
        this.setState({
          mensajeFlashSeverity: "danger",
          mensajeFlash: response.mensaje,
          mostrarMensajeFlash: true,
          openPantallaCarga: false,
        });
      } else {
        this.setState({
          mensajeFlash: "Lote y recibos asociados eliminados",
          mensajeFlashSeverity: "success",
          mostrarMensajeFlash: true,
          openPantallaCarga: false,
        });
      }
      this.fetchLotes(0, this.state.pageSize, "");
      this.handleDialogEliminarLote(false);
      this.fetchLotes(0, this.state.pageSize, "");
    });
  };

  handleCloseMensajeFlash = () => {
    this.setState({
      mostrarMensajeFlash: false,
    });
  };
  handlePageSizeChange(event) {
    const pageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize, page: 0 }, () => {
      this.fetchLotes();
    });
  }

  handlePageChange(newPage) {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchLotes(newPage, this.state.pageSize, "");
      });
    }
  }

  handlePageChange = (newPage) => {
    if (newPage >= 0 && newPage < this.state.totalPages) {
      this.setState({ page: newPage }, () => {
        this.fetchLotes(this.state.page, this.state.pageSize, "");
      });
    }
  };

  handlePageSizeChange = (event) => {
    const newPageSize = parseInt(event.target.value, 10);
    this.setState({ pageSize: newPageSize, page: 0 }, () => {
      this.fetchLotes(this.state.page, this.state.pageSize, "");
    });
  };

  renderPageNumbers() {
    const { page, totalPages } = this.state;
    const maxVisiblePages = 5; // Máximo de páginas visibles

    let pages = [];

    if (totalPages <= maxVisiblePages) {
      // Mostrar todas las páginas si son pocas
      for (let i = 0; i < totalPages; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }
    } else {
      // Mostrar primeras páginas, últimas y cercanas a la actual
      const startPage = Math.max(0, page - 2);
      const endPage = Math.min(totalPages - 1, page + 2);

      // Agregar primera página
      if (startPage > 0) {
        pages.push(
          <li
            key={0}
            className={`page-item ${page === 0 ? "active" : ""}`}
            onClick={() => this.handlePageChange(0)}
          >
            <a className="page-link" type="Button">
              1
            </a>
          </li>
        );
        if (startPage > 1) {
          pages.push(
            <li key="start-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
      }

      // Agregar páginas visibles
      for (let i = startPage; i <= endPage; i++) {
        pages.push(
          <li
            key={i}
            className={`page-item ${page === i ? "active" : ""}`}
            onClick={() => this.handlePageChange(i)}
          >
            <a className="page-link" type="Button">
              {i + 1}
            </a>
          </li>
        );
      }

      // Agregar última página
      if (endPage < totalPages - 1) {
        if (endPage < totalPages - 2) {
          pages.push(
            <li key="end-ellipsis" className="page-item disabled">
              <span className="page-link">...</span>
            </li>
          );
        }
        pages.push(
          <li
            key={totalPages - 1}
            className={`page-item ${page === totalPages - 1 ? "active" : ""}`}
            onClick={() => this.handlePageChange(totalPages - 1)}
          >
            <a className="page-link" type="Button">
              {totalPages}
            </a>
          </li>
        );
      }
    }

    return pages;
  }

  componentDidMount() {
    this.fetchLotes(0, this.state.pageSize, ""); // Página inicial, tamaño y búsqueda vacía
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.lotesData.lotes !== this.props.lotesData.lotes &&
      this.props.lotesData.lotes.length > 0
    ) {
      requestAnimationFrame(() => {
        swipeActions();
      });
    }
  }

  fetchLotes(page, pageSize, search) {
    this.setState({ loading: true });
    this.props.getLotes(page, pageSize, search).then(() => {
      this.setState({
        lotes: this.props.lotesData.lotes,
        page: this.props.lotesData.page,
        totalCount: this.props.lotesData.totalCount,
        totalPages: Math.ceil(this.props.lotesData.totalCount / pageSize),
        loading: false,
      });
    });
  }

  handleSearchChange = (e) => {
    const searchValue = e.target.value;
    this.setState({ search: searchValue }, () => {
      this.fetchLotes(0, this.state.pageSize, this.state.search);
    });
  };

  renderizarComponenteConElementos = () => {
    return (
      <div>
        <div className="component-pagination">
          <h5 className="list-title">Lotes para Publicar</h5>

          <div className="pagination-actions">
            {/* Buscador */}
            <form className="search-form form">
              <div className="search-group">
                <div className="input-icon">
                  <span className="material-symbols-outlined">search</span>
                </div>
                <input
                  type="search"
                  className="input-search"
                  placeholder="Buscar.."
                  aria-label="Search"
                  value={this.state.search}
                  onChange={this.handleSearchChange}
                />
              </div>
            </form>

            {/* Paginador */}
            <div className="pagination">
              <span className="info-pages">
                {this.state.page * this.state.pageSize + 1}-
                {Math.min(
                  (this.state.page + 1) * this.state.pageSize,
                  this.state.totalCount
                )}{" "}
                de {this.state.totalCount}
              </span>

              <button
                className={`btn-prev ${
                  this.state.page === 0 ? "btn-disabled" : ""
                }`}
                onClick={() => this.handlePageChange(this.state.page - 1)}
                disabled={this.state.page === 0}
              >
                <span className="material-symbols-outlined">navigate_before</span>
              </button>

              <button
                className={`btn-next ${
                  this.state.page === this.state.totalPages - 1
                    ? "btn-disabled"
                    : ""
                }`}
                onClick={() => this.handlePageChange(this.state.page + 1)}
                disabled={this.state.page === this.state.totalPages - 1}
              >
                <span className="material-symbols-outlined">navigate_next</span>
              </button>
            </div>
          </div>
        </div>

        <div>
          {this.state.loading ? (
            <div className="d-flex justify-content-center p-5">
              <Spinner animation="border" role="status">
                <span className="visually-hidden">Cargando...</span>
              </Spinner>
            </div>
          ) : (
            <div className="component-lista-documentos">
              <div className="component-container">
                {this.props.lotesData.lotes.map((lote, index) => (
                  <div key={index} className="list-item item-pending">
                    <Link
                      to={{
                        pathname: "/lote/recibos/publicar/" + lote.id,
                        state: { lote, estado: "publicar" },
                      }}
                      className="list-item__link"
                    >
                      <div className="item-info">
                        <div className="item-copy">
                          <span className="copy__uppertitle">
                            Documentos para Publicar
                          </span>
                          <h3 className="copy__title">{lote.descripcion}</h3>
                          <p className="copy__description">
                            {lote.tipoDocumento}
                          </p>
                        </div>
                      </div>

                      <div className="item-elements">
                        <div className="item__status">
                          <span className="label__warning">{lote.estado}</span>
                          <span className="label__info">
                            {lote.estadoMTESS
                              ? "Aprobado MTESS"
                              : "Pendiente MTESS"}
                          </span>
                        </div>
                        <span className="item__number">#{lote.numero}</span>
                        <time
                          className="item__date"
                          dateTime={lote.fechaImportacion}
                        >
                          {new Date(lote.fechaImportacion).toLocaleDateString(
                            "es-ES",
                            {
                              day: "numeric",
                              month: "short",
                              year: "numeric",
                            }
                          )}
                        </time>
                      </div>
                    </Link>
                    <div className="item-actions">
                      <Link
                        to={{
                          pathname: "/lote/recibos/publicar/" + lote.id,
                          state: { lote, estado: "publicar" },
                        }}
                        className="btn-small btn-primary-tonal btn-circle-icon"
                      >
                        <span class="material-symbols-outlined">
                          assignment
                        </span>
                        <span className="mobile-txt">Ver PDF</span>
                      </Link>
                      <a
                        onClick={() =>
                          this.handleDialogEliminarLote(true, lote)
                        }
                        className="btn-small btn-primary-tonal btn-circle-icon"
                      >
                        <span className="material-symbols-outlined">
                          delete
                        </span>
                        <span className="mobile-txt">Eliminar</span>
                      </a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  renderizarComponenteSinElementos = () => {
    return (
      <div>
        <div className="component-pagination">
          <h5 className="list-title">Lotes Publicados</h5>
        </div>
        <ComponenteVacio />
      </div>
    );
  };

  render() {
    return (
      <div>
        <PantallaCarga open={this.state.openPantallaCarga} />
        <ModalEliminarConDetalles
          isOpen={this.state.dialogEliminarLote}
          titulo="Lote"
          elemento={this.state.lote}
          onConfirmar={this.handleDelete}
          cerrarModal={this.handleCerrarDialogEliminarLote}
          onResultado={this.manejarResultado}
          onError={this.manejarError}
          detallesAMostrar={[
            { clave: "descripcion", etiqueta: "Descripcion del lote" },
          ]}
          mensaje="Esta acción eliminará permanentemente el lote"
          textoBotonAccion="CONFIRMAR ELIMINACIÓN"
        />

        <MensajeFlash
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
          open={this.state.mostrarMensajeFlash}
          handleClose={this.handleCloseMensajeFlash}
        />

        {this.state.lotes.length > 0
          ? this.renderizarComponenteConElementos()
          : this.renderizarComponenteSinElementos()}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  getLotes: (page, size, search) => dispatch(getLotes(page, size, search)),
});
const mapStateToProps = (state) => ({
  lotesData: state.lotesData,
});

export default connect(mapStateToProps, mapDispatchToProps)(LotesPublicar);
